import React, { useEffect, useImperativeHandle, useState } from "react";
import {
  Modal,
  Space,
  Row,
  Col,
  Button,
  Form,
  Input,
  Typography,
  Divider,
  Descriptions,
  List,
  Table,
  Radio,
  Checkbox,
  Select,
  Tooltip,
} from "antd";
import "./NewBedCatalog.scss";
import Icons from "assets/icons";
import { inpatientService } from "api";

const NewBedCatalog = React.forwardRef((props: any, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [danhMucDichVuGiuong, setDanhMucDichVuGiuong] = useState<any>([]);
  const [data, setData] = useState<any>(null);
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    getValue: form.getFieldValue,
    getValues: form.getFieldsValue,
    setValue: form.setFieldValue,
    setValues: form.setFieldsValue,
    resetFields: form.resetFields,
    setData: setData,
  }));
  const fetchDanhMucDichVuGiuong = async () => {
    try {
      let response = await inpatientService.getDanhMucDichVuGiuong();
      console.log(
        "🚀 ~ file: NewBedCatalog.tsx:46 ~ fetchDanhMucDichVuGiuong ~ response:",
        response
      );
      setDanhMucDichVuGiuong(response);
    } catch (err) {}
  };
  const onFinish = async (values) => {};
  const handleOnClick = async () => {
    let tenPhong = props.danhMucPhong.data.find(
      (it) => it.id === form.getFieldValue("idPhong")
    )?.tenPhong;
    let tmp = {
      ...form.getFieldsValue(),
      tenBuongPhong: tenPhong,
    };
    if (data) {
      await props.onSave(
        {
          ...data,
          ...tmp,
        },
        1
      );
    } else {
      await props.onSave(
        {
          ...tmp,
        },
        0
      );
    }

    closeModal();
  };

  useEffect(() => {});
  useEffect(() => {}, [isModalOpen]);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    fetchDanhMucDichVuGiuong();
  }, []);
  useEffect(() => {}, [props.danhMucPhong, danhMucDichVuGiuong]);
  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);
  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={"Thêm mới danh mục giường bệnh"}
        destroyOnClose
        width={960}
      >
        <Row>
          <Row>
            <Form form={form} onFinish={onFinish}>
              <Row gutter={[4, 8]}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Phòng</Typography.Text>}
                    name="idPhong"
                    labelAlign="left"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                  >
                    <Select
                      className="data-select-field"
                      placeholder="Chọn"
                      options={
                        props.danhMucPhong?.data
                          ? props.danhMucPhong?.data?.map((it) => ({
                              value: it.id,
                              label: it.tenPhong,
                            }))
                          : []
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Mã giường</Typography.Text>
                    }
                    name="maGiuong"
                    labelAlign="left"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                  >
                    <Input className="data-input-field" placeholder="Nhập" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Số giường</Typography.Text>
                    }
                    name="soGiuong"
                    labelAlign="left"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                  >
                    <Input className="data-input-field" placeholder="Nhập" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    label={
                      <Tooltip
                        title="Dịch vụ giường"
                        arrow={false}
                      >
                        <Typography.Text ellipsis>
                          Dịch vụ giường
                        </Typography.Text>
                      </Tooltip>
                    }
                    name="dichVuGiuong"
                    labelAlign="left"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                  >
                    <Select
                      className="data-select-field"
                      placeholder="Nhập"
                      options={danhMucDichVuGiuong?.map((it) => ({
                        value: it.id,
                        label: it.tenDichVu,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Giá giường</Typography.Text>
                    }
                    name="giaGiuong"
                    labelAlign="left"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                  >
                    <Input className="data-input-field" placeholder="Nhập" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>BH chi trả</Typography.Text>
                    }
                    name="baoHiemChiTra"
                    labelAlign="left"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                  >
                    <Input className="data-input-field" placeholder="Nhập" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
          <Row justify={"end"} style={{ gap: "4px", marginTop: "4px" }}>
            <Button
              type="primary"
              icon={<Icons.close rev={0} />}
              danger
              onClick={closeModal}
            >
              Hủy
            </Button>
            <Button
              type="primary"
              icon={<Icons.save rev={0} />}
              onClick={handleOnClick}
            >
              Lưu
            </Button>
          </Row>
        </Row>
      </Modal>
    </div>
  );
});

export default NewBedCatalog;
